import Vue from "vue";
import Router from "vue-router";
import register from "@/components/auth/register";
import login from "@/components/auth/login";
import auth from "@/components/auth/auth";
import admin from "@/components/admin/admin";
import thirdAppAuth from "@/components/auth/thirdapp_auth";
import password_reset from "@/components/auth/password_reset";
import confirm from "@/components/auth/confirm";
import session from "@/components/auth/session";
import incompatible from "@/components/auth/incompatible";
import notfound from "@/components/auth/404";
import maintenance from "@/components/auth/maintenance";
import access_denied from "@/components/auth/access_denied";
import memberInvite from "@/components/auth/member_invite";
import index from "@/components/index";
import influencer from "@/components/influencer/i_search";
import youtuber from "@/components/influencer/y_search";
import tiktoker from "@/components/influencer/tt_search";
import tiktokerDetail from "@/components/influencer/tt_detail";
import twitterer from "@/components/influencer/tw_search";
import twittererDetail from "@/components/influencer/tw_detail";
import influencerDetail from "@/components/influencer/i_detail";
import youtuberDetail from "@/components/influencer/y_detail";
import dashboard from "@/components/dashboard";
import unpermitted from "@/components/unpermitted";
import setting from "@/components/setting/setting";
import accountSetting from "@/components/setting/account_setting";
import upgradePurchase from "@/components/setting/upgrade_purchase";
import media from "@/components/media/m_search";
import list from "@/components/list/list";
import influencerListDetail from "@/components/list/list_detail";
import report from "@/components/report/report";
import reportDetail from "@/components/report/report_detail";
// import youtuberListDetail from '@/components/list/y_list_detail'
import message from "@/components/message/message";
import request from "@/components/request/request";
// import reportInfluencer from "@/components/report/report_influencer";
// import tiktok from "@/components/tiktok";
import ElementUI from "element-ui";
import store from "./store";
import axios from "axios"; //追記
import firebase from "firebase/compat/app";
import "firebase/auth";
import "firebase/firestore";
import { TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN } from "./const/plan";

Vue.use(Router);
Vue.use(ElementUI);

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes: [
    {
      path: "/register/:oem_token", //パスの設定
      component: register, //表示するコンポーネント
      name: "registerWithToken", //ルートの名前を指定
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/DFSw2tXhxKgReflTBpvhxdfb8fGAJX3M", //パスの設定
      component: register, //表示するコンポーネント
      name: "register", //ルートの名前を指定
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/login",
      component: login,
      name: "login",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/auth",
      component: auth,
      name: "auth",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/auth/thirdapp",
      component: thirdAppAuth,
      name: "thirdAppAuth",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/password_reset",
      component: password_reset,
      name: "password_reset",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/confirm",
      component: confirm,
      name: "confirm",
    },
    {
      path: "/session",
      component: session,
      name: "session",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/incompatible",
      component: incompatible,
      name: "incompatible",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/member_invite/:member_link",
      component: memberInvite,
      name: "memberInvite",
      prpos: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "*",
      component: notfound,
      name: "404",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/maintenance",
      component: maintenance,
      name: "maintenance",
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/access_denied",
      component: access_denied,
      name: "access_denied",
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/",
      component: index,
      name: "index",
      props: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/instagram/:account_name",
          component: influencerDetail,
          name: "influencerDetail",
          props: true,
          meta: {
            restrictAccess: true,
          },
        },
        {
          path: "/youtube/:channel_id",
          component: youtuberDetail,
          name: "youtuberDetail",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
        },
        {
          path: "/tiktok/:account_name",
          component: tiktokerDetail,
          name: "tiktokerDetail",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
        },
        {
          path: "/twitter/:account_name",
          component: twittererDetail,
          name: "twittererDetail",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
        },
        {
          path: "/instagram",
          component: influencer,
          name: "influencer",
          props: true,
          meta: {
            restrictAccess: true,
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "instagram_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "instagram_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "instagram_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "instagram_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/youtube",
          component: youtuber,
          name: "youtuber",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "youtube_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "youtube_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "youtube_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "youtube_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/tiktok",
          component: tiktoker,
          name: "tiktoker",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "tiktok_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "tiktok_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "tiktok_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "tiktok_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/twitter",
          component: twitterer,
          name: "twitterer",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "twitter_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "twitter_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "twitter_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "twitter_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/admin",
          component: admin,
          name: "admin",
          props: true,
          meta: {
            requiresAuth: true,
            adminAuth: true,
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "admin_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "admin_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "admin_tiktokerDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/dashboard",
          component: dashboard,
          name: "dashboard",
        },
        {
          path: "/setting",
          component: setting,
          name: "setting",
          props: true,
        },
        {
          path: "/account_setting",
          component: accountSetting,
          name: "accountSetting",
          props: true,
        },
        {
          path: "/request",
          component: request,
          name: "request",
          props: true,
          meta: {
            restrictAccess: true,
          },
        },
        {
          path: "/setting/upgrade",
          component: upgradePurchase,
          name: "upgrade",
          props: true,
        },
        {
          path: "/media",
          component: media,
          name: "media",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "media_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "media_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "media_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "media_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/list",
          component: list,
          name: "list",
          props: true,
        },
        {
          path: "/list/:list_id",
          name: "listDetail",
          props: (route) => ({
            list_id: Number(route.params.list_id),
          }),
          meta: {
            restrictAccess: true,
          },
          component: influencerListDetail,
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "list_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "list_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "list_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "list_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/report",
          component: report,
          name: "report",
          props: true,
        },
        {
          path: "/report/:report_id",
          name: "reportDetail",
          props: true,
          meta: {
            restrictAccess: true,
          },
          component: reportDetail,
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "report_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "report_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "report_tiktokerDetailDrawer",
              props: true,
            },
            {
              path: "/twitter/:account_name",
              component: twittererDetail,
              name: "report_twittererDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/message",
          component: message,
          name: "message",
          props: true,
          meta: {
            restrictAccess: true,
            gate: [TRIAL, MANAGER, PARTNER, PRO, ENTERPRISE, ADMIN],
          },
          children: [
            {
              path: "/instagram/:account_name",
              component: influencerDetail,
              name: "direct_influencerDetailDrawer",
              props: true,
            },
            {
              path: "/youtube/:channel_id",
              component: youtuberDetail,
              name: "direct_youtuberDetailDrawer",
              props: true,
            },
            {
              path: "/tiktok/:account_name",
              component: tiktokerDetail,
              name: "direct_tiktokerDetailDrawer",
              props: true,
            },
          ],
        },
        {
          path: "/unpermitted",
          component: unpermitted,
          name: "unpermitted",
        },
        // {
        //   path: "/tiktok",
        //   component: tiktok,
        //   name: "tiktok",
        // },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const adminAuth = to.matched.some((record) => record.meta.adminAuth);
  const restrictAccess = to.matched.some(
    (record) => record.meta.restrictAccess
  );
  const gate = to.matched
    .filter((record) => record.meta.gate !== undefined)
    .find((record) => record.meta.gate !== undefined)?.meta?.gate;
  const root = process.env.VUE_APP_API;
  const sessionAPI = root + "/api/auth/session";
  const protocol = window.location.protocol; // "http:" または "https:"
  const hostname = window.location.hostname; // "127.0.0.1"
  const port = window.location.port; // "8080"
  const fullUrl = `${protocol}//${hostname}${port ? ":" + port : ""}`;
  // const user = firebase.auth().currentUser;
  // REECH用クライアント登録画面にアクセスする場合にはREECHドメイン制限をかける
  if (to.name === "register") {
    if (root != fullUrl) {
      // 許可されていないドメインからのアクセスの場合、404にリダイレクト
      return next("/404");
    }
  }

  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    firebase.auth().onAuthStateChanged((user) => {
      if (user == null || !store.state.token) {
        next({
          path: "/login",
          query: {
            to: to.path,
          },
        });
      } else if (user.emailVerified && to.params.backpage == true) {
        next();
      } else if (user.emailVerified) {
        axios
          .get(sessionAPI, {
            params: {
              user_token: user.uid,
              path: to.path,
              id_session: store.state.id_session,
            },
          })
          .then((response) => {
            if (response.data.notes == "maintenance") {
              next({ path: "/maintenance" });
            } else if (response.data.status == "NG") {
              next({ path: "/session" });
            } else if (
              response.data.status == "unpermitted" &&
              to.path.match(/\/(list|report)\/[0-9]*/)
            ) {
              next({ path: "/404" });
            } else if (response.data.allow_ip === false) {
              next({ path: "/access_denied" });
            } else if (restrictAccess && response.data.activate < 10) {
              next({ path: "/dashboard" });
            } else if (adminAuth && !response.data.adminAuth) {
              next({ path: "/404" });
            } else {
              if (gate !== undefined && !gate.includes(response.data.activate))
                next({ path: "/404", replace: true }); // TODO:厳密には403ページだがページが存在しないので暫定的に設定
              next();
            }
          });
      } else {
        console.log("/confirm");
        next({
          path: "/confirm",
          query: {
            token: user.uid,
          },
        });
      }
    });
  } else {
    next(); // next() を常に呼び出すようにしてください!
  }
});
router.afterEach(() => {
  firebase.auth().onAuthStateChanged((user) => {
    if (
      window.clarity &&
      typeof window.clarity === "function" &&
      user != null &&
      store.state.member_info.email !== ""
    ) {
      window.clarity("identify", store.state.member_info.email);
    }
  });
});

export default router;
